import { render, staticRenderFns } from "./TabVisualizacaoTurma.vue?vue&type=template&id=fc8f4188"
import script from "./TabVisualizacaoTurma.vue?vue&type=script&lang=js"
export * from "./TabVisualizacaoTurma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports